import React from 'react';
import { MessageSquare, Clock, User } from 'lucide-react';

interface TutorSessionProps {
  id: string;
  topic: string;
  status: 'pending' | 'active' | 'completed' | 'cancelled';
  startTime?: string;
  onJoin: () => void;
  onCancel: () => void;
}

export default function TutorSession({
  topic,
  status,
  startTime,
  onJoin,
  onCancel
}: TutorSessionProps) {
  const getStatusColor = () => {
    switch (status) {
      case 'active':
        return 'bg-green-100 text-green-800';
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'completed':
        return 'bg-gray-100 text-gray-800';
      case 'cancelled':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center">
          <MessageSquare className="w-6 h-6 text-purple-600 mr-3" />
          <div>
            <h3 className="text-lg font-semibold text-gray-900">{topic}</h3>
            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium mt-1 ${getStatusColor()}`}>
              {status.charAt(0).toUpperCase() + status.slice(1)}
            </span>
          </div>
        </div>
      </div>

      {startTime && (
        <div className="flex items-center text-sm text-gray-500 mb-4">
          <Clock className="w-4 h-4 mr-2" />
          <span>{startTime}</span>
        </div>
      )}

      <div className="flex items-center justify-end space-x-3">
        {status === 'pending' && (
          <button
            onClick={onCancel}
            className="text-gray-600 hover:text-gray-800 text-sm font-medium"
          >
            Cancel
          </button>
        )}
        {(status === 'pending' || status === 'active') && (
          <button
            onClick={onJoin}
            className="bg-purple-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-purple-700 transition-colors"
          >
            Join Session
          </button>
        )}
      </div>
    </div>
  );
}